"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.humidityRatioConversions = humidityRatioConversions;
const calculations_1 = require("@munters/calculations");
function humidityRatioConversions(fromAmount, to, conversionParameters) {
    const pressureAmount = conversionParameters.pressure;
    const temperatureAmount = conversionParameters.temperature;
    switch (to) {
        case "RelativeHumidity": {
            return calculations_1.Physics.RP1485.AmountConversions.humidityRatioToRelativeHumidity(pressureAmount, temperatureAmount, fromAmount);
        }
        case "SpecificEnthalpy": {
            return calculations_1.Physics.RP1485.AmountConversions.humidityRatioToSpecificEnthalpy(pressureAmount, temperatureAmount, fromAmount);
        }
        case "DewPointTemperature": {
            return calculations_1.Physics.RP1485.AmountConversions.humidityRatioToDewPointTemperature(pressureAmount, fromAmount);
        }
        case "WetTemperature": {
            return calculations_1.Physics.RP1485.AmountConversions.humidityRatioToWetTemperature(pressureAmount, temperatureAmount, fromAmount);
        }
        default: {
            throw new Error(`Can't convert ${fromAmount.unit.quantity} to ${to}`);
        }
    }
}
//# sourceMappingURL=humidity-ratio-conversions.js.map